export default function MeasureUnit({ number, measureUnit, decimals = 0 }) {
	number = parseFloat(number);
	if (isNaN(number)) {
		number = null;
	}

	if (!number) {
		return null;
	}

	return (
		<>
			{number.toFixed(decimals)} {measureUnit}
		</>
	);
}
